export default __webpack_public_path__ + "locales/tr/PortalUnavailable.json?hash=0d2cd30f0593fdf1c74be10370c93c5e";